import React from 'react'
import { Icon } from './Icon'
import { hoverAttrs } from './useHoverEffect'
import { ButtonItem } from './types'

type Props = ButtonItem & {
  hasIcon?: boolean
}

const BaseButton: React.FC<Props> = ({ href, label, color, hasIcon = false }) => (
  <div className={`c-button__base ${hasIcon ? '--icon' : ''} --full color-${color}`}>
    <a {...hoverAttrs(300, 600)} href={href} className="c-button__base--link c-link__button">
      <span className="--bg c-button__base--bg" />
      <p className="--text c-button__base--text">{label}</p>
      {hasIcon && (
        <div className="c-button__base--icon">
          <Icon name="arrow" viewBox="0 0 20 20" className="--icon c-icon__full" />
        </div>
      )}
    </a>
  </div>
)

export default BaseButton
